// v1.0 - modified
var id = document.currentScript.getAttribute('id');
var post_data = "id="+id;

// Anonymous "self-invoking" function
(function() {
    var startingTime = new Date().getTime();
    // Load the script
    var script = document.createElement("SCRIPT");
    script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js';
    script.type = 'text/javascript';
    document.getElementsByTagName("head")[0].appendChild(script);

    // Poll for jQuery to come into existance
    var checkReady = function(callback) {
        if (window.jQuery) {
            callback(jQuery);
        }
        else {
            window.setTimeout(function() { checkReady(callback); }, 20);
        }
    };

    // Start polling...
    checkReady(function($) {
        $(function() {
			
			$.ajax({
				url: 'https://wotio.app/util_custactivate.php',
				type: 'POST',
				data: post_data,
				dataType: 'html',
				success: function(data) {
					$('.AAI-customeractivate-custom').each(function() {
            $(this).html(data);
            $(this).after(`
              <div class="text-center">
                <a class="text-link" href="/pages/activate-existing-account">${window.theme.strings.troubleLoggingIn}</a>
              </div>
            `);
          });
          // custom listeners
          $('#AAI-buttontext a').each(function() {
            $(this).click((evt) => { AAI_openModalCustom(evt); })
          });
          $('#AAI-cancel a').each(function() {
            $(this).click((evt) => { AAI_closeCustom(evt); })
          });
          $('#AAI-close a').each(function() {
            $(this).click((evt) => { AAI_closeCustom(evt); })
          });
          $('#AAI-submitbtn input[name="AAI_button"]').each(function() {
            $(this).click((evt) => { AAI_processFormCustom(evt); })
          })
				},
				error: function() {
					//alert("Something went wrong!");
				}
			});
            
        });
    });
})();


//document.write(id);

function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function AAI_openModal(token){
	// $('#AAI-modal').show();
  // $('#AAI-background').show();
}

function AAI_openModalCustom(evt) {
  var target = evt.target;
  var parent = target.closest('.AAI-customeractivate-custom');
  if (!parent) return;

  var modal = $(parent).find('#AAI-modal');
  var background = $(parent).find('#AAI-background');

  $(modal).show();
  $(background).show();
}

function AAI_close() {
	// $('#AAI-modal').hide();
  // $('#AAI-background').hide();
	// $('#AAI-headline').show();
	// $('#AAI-instructions').show();
	// $('#AAI-form').show();
	// $('#AAI-processing').hide();
	// $('#AAI-error').hide();
	// $('#AAI-confirmation').hide();
	// $("#AAI-activateform")[0].reset();
}

function AAI_closeCustom(evt) {
  var target = evt.target;
  var parent = target.closest('.AAI-customeractivate-custom');
  if (!parent) return;

  var modal = $(parent).find('#AAI-modal');
  var background = $(parent).find('#AAI-background');
  var headline = $(parent).find('#AAI-headline');
  var instructions = $(parent).find('#AAI-instructions'); 
  var form = $(parent).find('#AAI-form');
  var processing = $(parent).find('#AAI-processing');
  var error = $(parent).find('#AAI-error');
  var confirmation = $(parent).find('#AAI-confirmation');
  var activateform = $(parent).find('#AAI-activateform');

  $(modal).hide();
  $(background).hide();
	$(headline).show();
	$(instructions).show();
	$(form).show();
	$(processing).hide();
	$(error).hide();
	$(confirmation).hide();
	$(activateform)[0].reset();
}

function AAI_processForm() {
	// var email = document.getElementById('AAI_email').value;
	// var token = document.getElementById('AAI_token').value;
	
	// if(email == '' || email == null) {
	// 		document.getElementById("AAI_email").focus();
	// 		return false;
	// 	}
		
	// if (validateEmail(email)) {
		
	// 	//hide elements
	// 	$('#AAI-headline').hide();
	// 	$('#AAI-instructions').hide();
	// 	$('#AAI-form').hide();
	// 	$('#AAI-processing').show();
    	
	// 	//send email to script
	// 	var post_data = "e="+email+"&t="+token;

	// 	$.ajax({
	// 		url: 'https://wotio.app/util_custactivate_invite.php',
	// 		type: 'POST',
	// 		data: post_data,
	// 		dataType: 'html',
	// 		success: function(data) {
	// 			$('#AAI-processing').hide();
	// 			$('#AAI-confirmation').show();
	// 		},
	// 		error: function() {
	// 			//alert("Something went wrong!");
	// 			$('#AAI-processing').hide();
	// 			$('#AAI-confirmation').show();
	// 		}
	// 	});
		
		
  // 	} else {
	// 	$('#AAI-error').show();
	// 	document.getElementById("AAI_email").focus();
  //   	return false;
  // 	}
	
}

function AAI_processFormCustom(evt) {
  var target = evt.target;
  var parent = target.closest('.AAI-customeractivate-custom');
  console.log('parent: ', parent);
  if (!parent) return;

  var email = $(parent).find('#AAI_email').val();
  var token = $(parent).find('#AAI_token').val();

  if(email == '' || email == null) {
    $(parent).find("#AAI_email").focus();
    return false;
  }

  var headline = $(parent).find('#AAI-headline');
  var instructions = $(parent).find('#AAI-instructions'); 
  var form = $(parent).find('#AAI-form');
  var processing = $(parent).find('#AAI-processing');
  var confirmation = $(parent).find('#AAI-confirmation');
  var error = $(parent).find('#AAI-error');

  if (validateEmail(email)) {
		//hide elements
		$(headline).hide();
		$(instructions).hide();
		$(form).hide();
		$(processing).show();
    	
		//send email to script
		var post_data = "e="+email+"&t="+token;

		$.ajax({
			url: 'https://wotio.app/util_custactivate_invite.php',
			type: 'POST',
			data: post_data,
			dataType: 'html',
			success: function(data) {
				$(processing).hide();
				$(confirmation).show();
			},
			error: function() {
				//alert("Something went wrong!");
				$(processing).hide();
				$(confirmation).show();
			}
		});
		
		
  	} else {
      $(error).show();
      $(parent).find("#AAI_email").focus();
        return false;
      }
}